import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Grid from '@mui/material/Grid';
import Button from '../../../layouts/theme-onboarding/Button';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import Color from '../../../layouts/Color';

const cardStyle = { maxWidth: 345, minHeight: 180 };
const container = { mt: 3 };
const cardActionStyle = { justifyContent: 'center' };
const buttonDelete = {
    color: Color.Button,
    backgroundColor: Color.Dangerous,
    '&:hover': { background: Color.Button, color: Color.Normal }
  };

export default function ListAddress(props) {

    const handleDeletePermanentAddress = () => {
        props.deletePermanentAddress();
    }

    const handleDeleteCardAddress = () => {
        props.deleteCardAddress();
    }

    const renderBaseAddress = () => {
        let listAddresses = props.listAddresses;
        return listAddresses.baseAddress !== null ? (
            <Grid item xs={12} sm={4}>
                <Card sx={cardStyle}>
                    <CardContent>
                        <Typography variant="subtitle1" color={Color.Main}>
                            Base Address
                        </Typography>
                        <Typography variant="body2" color={Color.Normal}>
                            {listAddresses.baseAddress}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>) : (<Grid item xs={12} sm={4}></Grid>)
    }

    const renderPermanentAddress = () => {
        let listAddresses = props.listAddresses;
        return listAddresses.permanentAddress !== null ? (
            <Grid item xs={12} sm={4}>
                <Card sx={cardStyle}>
                    <CardContent>
                        <Typography variant="subtitle1" color={Color.Main}>
                            Permanent Address
                        </Typography>
                        <Typography variant="body2" color={Color.Normal}>
                            {listAddresses.permanentAddress}
                        </Typography>
                    </CardContent>
                    <CardActions sx={cardActionStyle}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <label htmlFor="contained-button-file">
                                <Button variant="contained" 
                                    component="span" sx={buttonDelete} onClick={handleDeletePermanentAddress}>
                                    Delete <DeleteIcon></DeleteIcon>
                                </Button>
                            </label>
                        </Stack>
                    </CardActions>
                </Card>
            </Grid>
        ) : (<Grid item xs={12} sm={4}></Grid>)
    }

    const renderCardAddress = () => {
        let listAddresses = props.listAddresses;
        return listAddresses.cardAddress !== null ? (
            <Grid item xs={12} sm={4}>
                <Card sx={cardStyle}>
                    <CardContent>
                        <Typography variant="subtitle1" color={Color.Main}>
                            Card Address
                        </Typography>
                        <Typography variant="body2" color={Color.Normal}>
                            {listAddresses.cardAddress}
                        </Typography>
                    </CardContent>
                    <CardActions sx={cardActionStyle}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <label htmlFor="contained-button-file">
                                <Button variant="contained" 
                                    component="span" sx={buttonDelete}
                                    onClick={handleDeleteCardAddress}>
                                    Delete <DeleteIcon></DeleteIcon>
                                </Button>
                            </label>
                        </Stack>
                    </CardActions>
                </Card>
            </Grid>
        ) : (<Grid item xs={12} sm={4}></Grid>)
    }

    return (
        <React.Fragment>
            <Grid container spacing={3} sx={container}>
                <>
                    {renderBaseAddress()}
                    {renderPermanentAddress()}
                    {renderCardAddress()}
                </>
            </Grid>
        </React.Fragment>
    );
}